import styled from 'styled-components';

const CardLayout = styled.div`
  width: 100%;
  height: 100%;
`;

export default CardLayout;